export const reporterDomains = {
    "workAnalysisWorkBreakdown": {
        "domain": {
            "select": [
                "Event"
            ],
            "filters": []
        }
    },
    "workAnalysisTopWorkThemes": {
        "domain": {
            "select": [
                "Event"
            ],
            "filters": []
        }
    },
    "workAnalysisExecutiveSummary": {
        "domain": {
            "select": [
                "Event"
            ],
            "filters": []
        }
    },
    "WorkAnalysisInternalReleaseNotes": {
        "domain": {
            "select": [
                "Event"
            ],
            "filters": [
                {
                    "target": "Event",
                    "attribute": "EntityType",
                    "comparison": {
                        "IN": [
                            "Commit",
                            "PullRequest",
                            "Issue"
                        ]
                    }
                }
            ]
        }
    },
    "timeAnalysisActivityBreakdown": {
        "domain": {
            "select": [
                "Event"
            ],
            "filters": []
        }
    },
    "timeAnalysisWorkloadAnalysis": {
        "domain": {
            "select": [
                "Event"
            ],
            "filters": []
        }
    },
    "timeAnalysisFocusTime": {
        "domain": {
            "select": [
                "Event"
            ],
            "filters": [
                {
                    "target": "Event",
                    "attribute": "EntityType",
                    "comparison": {
                        "IN": [
                            "CalendarEntry"
                        ]
                    }
                },
                {
                    "target": "Event",
                    "attribute": "Action",
                    "comparison": {
                        "IN": [
                            "started"
                        ]
                    }
                }
            ]
        }
    },
    "summaryGeneric": {
        "domain": {
            "select": []
        }
    },
    "summaryDetailedGeneric": {
        "domain": {
            "select": []
        }
    },
    "summaryIssue": {
        "domain": {
            "select": [
                "Issue"
            ]
        }
    },
    "summaryCommit": {
        "domain": {
            "select": [
                "Commit"
            ]
        }
    },
    "summaryPullRequest": {
        "domain": {
            "select": [
                "PullRequest"
            ]
        }
    },
    "summaryCalendarEvent": {
        "domain": {
            "select": [
                "CalendarEntry"
            ]
        }
    },
    "summarySlackMessage": {
        "domain": {
            "select": [
                "Message"
            ]
        }
    }
};
